<div class="auth-form-card">
  <div class="auth-form-header">
    <img
      src="/assets/logos/cyflare-one-logo-new-colors.png"
      alt="Cyflare One"
      class="auth-form-logo"
    />
    <h2>Set Up Authenticator App</h2>
  </div>

  <form [formGroup]="enterMfaForm">
    <p class="auth-form-description">
      Download an authenticator app on your iOS or Android device, then scan the QR code below.
    </p>

    @if (image()) {
      <div class="auth-form-qr">
        <img
          [src]="image()"
          alt="MFA QR code"
        />
      </div>
    }

    <p class="auth-form-description">
      Alternatively, type the following code into your app:
    </p>

    <div class="auth-form-field">
      <kendo-textarea
        fillMode="flat"
        [readonly]="true"
        [value]="secretCode() ?? ''"
        placeholder="QR code string"
      ></kendo-textarea>
    </div>

    <div class="auth-form-field">
      <kendo-floatinglabel text="Authenticator App Code">
        <input
          kendoTextBox
          class="form-control"
          formControlName="oneTimeCode"
        />
      </kendo-floatinglabel>
    </div>

    <div class="auth-form-submit">
      <button
        kendoButton
        class="cyflare-btn-primary cyflare-btn-lg cyflare-btn-block"
        type="button"
        [disabled]="!enterMfaForm.valid"
        (click)="setupMfa()"
      >
        Submit
      </button>
    </div>

    <div class="auth-form-footer">
      <span>Having trouble signing in?</span>
      <a
        href="mailto:support@cyflare.com"
        kendoButton
        fillMode="clear"
      >
        Contact Us
      </a>
    </div>

    <div class="auth-form-secondary">
      <button
        kendoButton
        class="cyflare-btn-secondary cyflare-btn-lg cyflare-btn-block"
        type="button"
        (click)="back()"
      >
        Go Back
      </button>
    </div>
  </form>
</div>
